module.exports = __webpack_public_path__ + "static/img_9603-8b7b1464e26df198352ba3f21b3a781e.webp";